import { ColDef, GridOptions } from '@ag-grid-community/core'
import { Component, Input, OnInit } from '@angular/core'
import { heliosDefaultColDef } from '@helios/ag-grid-config'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { tpiFieldMap, TpiModalInput } from '../../models/tpi-input.modal'
import { tpiDataField } from '../../models/transaction-details.model'
import { TransferPurchaseInfo } from '../../models/transferPurchaseInfo.model'
import { TpiDataModel } from './../../models/transaction-details.model'
@Component({
  selector: 'tpi-modal',
  templateUrl: './tpi-modal.component.html',
  styleUrls: ['./tpi-modal.component.scss'],
})
export class TpiModalComponent implements OnInit {
  @Input() tpiModalInput?: TpiModalInput
  private readonly tpiColDefs: ColDef[] = this.createTpiColumnDefs()

  tpiRowDataMap = new Map()
  tpiGridOptions: GridOptions = this.createTpiGridOptions()
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.tpiModalInput?.tpiDataMap) {
      const tpiMap = new Map(
        Object.entries<TransferPurchaseInfo>(this.tpiModalInput.tpiDataMap),
      )

      tpiMap.forEach((value, key) => {
        this.tpiRowDataMap.set(key, this.setTpiData(value))
      })
    }
  }

  setTpiData(tpiData: TransferPurchaseInfo) {
    const tpiRowData: TpiDataModel[] = []
    tpiFieldMap.forEach((value, key) => {
      const tpiDataMap = new Map(Object.entries(tpiData))
      const valueData = tpiDataMap.get(key)
      if (valueData) {
        tpiRowData.push({
          property: value,
          value: valueData,
        })
      }
    })
    return tpiRowData
  }

  private createTpiGridOptions(): GridOptions {
    return {
      defaultColDef: {
        ...heliosDefaultColDef,
        menuTabs: [],
      },
      sideBar: false,
      columnDefs: this.tpiColDefs,
    }
  }

  private createTpiColumnDefs(): ColDef[] {
    return [
      {
        field: tpiDataField('property'),
        headerName: 'Property',
      },

      {
        field: tpiDataField('value'),
        headerName: 'Value',
      },
    ]
  }
}
